<template>
  <main>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("route.plans") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn v-if="items.length < 5" color="primary" @click="createPlan">
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>
    <wrapping-table
      @on_dialog_close="onDialogClose"
      @get_items="getItems"
      pathName="plans"
      :headersName="headers"
      ref="table_ref"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-sm-center" :title="item.description">
          {{ item.description | truncate(40) }}
        </td>
        <td class="text-sm-center">{{ item.price }}</td>
        <td class="text-sm-center">{{ item.duration }}</td>
        <td class="text-sm-center">
          <v-chip :color="item.color"></v-chip>
        </td>
        <td>
          <v-btn
            :title="$t('label.services_plans_feature_values')"
            color="primary"
            icon
            fab
            small
            outlined
            :to="`/services/features-values?id=${item.slug}`"
          >
            <v-icon class="edit">mdi-book-open-variant</v-icon>
          </v-btn>
        </td>
        <td class="text-sm-center">
          <v-icon
            :title="$t('icon.edit')"
            small
            @click="handleEdit(item, index)"
            >mdi-pencil</v-icon
          >
          <v-icon
            :title="$t('icon.delete')"
            small
            @click="handleDelete(item, index)"
            >mdi-delete</v-icon
          >
        </td>
      </template>
      <!-- dialog -->
      <template #wrraping_dialog>
        <FormActions
          :v="$v"
          :form="form"
          :isEdit="isEdit"
          :loading="loading"
          @on_submit_form="handleSubmit"
          @change_locale="onLocaleChange"
        />
      </template>
      <!-- dialog -->
    </wrapping-table>
  </main>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
  minValue
} from "vuelidate/lib/validators";
import { maxWords } from "@/utils/validate.js";
import { ShowData } from "@/helpers/apiMethods";
import cookie from "js-cookie";
export default {
  name: "Plans",
  components: {
    FormActions: () => import("./formActions")
  },
  data() {
    return {
      headers: [
        "name",
        "desc",
        "price",
        "duration",
        "color",
        "features_values",
        "actions"
      ],
      form: {
        name: "",
        sub_name: "",
        description: "",
        price: "",
        duration: "",
        notes: "",
        color: {}
      },
      items: [],
      isEdit: false,
      loading: false,
      planIndex: "",
      locale: this.locale,
      planItem: {}
    };
  },

  methods: {
    onLocaleChange(locale) {
      this.locale = locale;
      this.handleShow(locale);
    },
    getItems(items) {
      this.items = items;
    },
    handleSubmit() {
      let reqData = {
        ...this.form,
        color: this.form.color.hex,
        service_id: this.$route.query.service_id
      };
      if (!this.isEdit) {
        // in case create
        this.loading = true;
        this.$refs.table_ref
          .handleOnCreate("plans", reqData, "plan")
          .finally(() => {
            this.loading = false;
          });
      } else {
        // in case edit
        reqData = {
          ...reqData,
          _method: "put",
          color: this.form.color,
          locale: this.locale
        };
        this.$refs.table_ref
          .handleOnEdit(
            "plans",
            reqData,
            this.planItem.slug,
            "plan",
            this.planIndex
          )
          .finally(() => {
            this.loading = false;
          });
      }
    },
    onDialogClose() {
      this.$v.form.$reset();
      this.isEdit = false;
      this.locale = cookie.get("language");

      for (const key in this.form) {
        if (key !== "color") {
          this.form[key] = "";
        } else {
          this.form["color"] = {};
        }
      }
    },
    createPlan() {
      this.$refs.table_ref.toggleDialog();
    },
    handleEdit(item, index) {
      this.planItem = item;
      this.planIndex = index;
      this.isEdit = true;
      this.$refs.table_ref.toggleDialog();

      this.handleShow();
    },
    async handleShow(locale = this.locale) {
      const res = await ShowData({
        reqName: "plans",
        id: this.planItem.slug,
        locale
      });
      const { plan } = res.data;
      this.form = plan;
    },
    handleDelete({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(30)
      },
      sub_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(150)
      },
      description: {
        required,
        minLength: minLength(3),
        maxWords: maxWords(50)
      },
      notes: {
        required,
        minLength: minLength(3),
        maxWords: maxWords(100)
      },
      price: {
        required,
        numeric,
        minValue: minValue(0)
      },
      duration: {
        required,
        numeric,
        minValue: minValue(0)
      }
    }
  }
};
</script>
